import { render, staticRenderFns } from "./editOrder.vue?vue&type=template&id=923c299a&scoped=true"
import script from "./editOrder.vue?vue&type=script&lang=js"
export * from "./editOrder.vue?vue&type=script&lang=js"
import style0 from "./editOrder.vue?vue&type=style&index=0&id=923c299a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923c299a",
  null
  
)

export default component.exports